import teams from "../json/teams";

const getTeams = () => {
  return teams;
}

export default getTeams;